/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GooseGamePlayerQueryVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Float"];
}>;

export type GooseGamePlayerQuery = {
  gooseGamePlayer: Pick<
    Types.GooseGamePlayer,
    | "id"
    | "event_attendee_id"
    | "current_points"
    | "total_points"
    | "created_at"
    | "dashboard_last_viewed_at"
  > & {
    event_attendee: Pick<Types.EventAttendee, "badge_code"> & {
      user: Pick<Types.User, "id" | "name" | "email">;
    };
  };
};

export const GooseGamePlayerDocument = gql`
  query GooseGamePlayer($event_attendee_id: Float!) {
    gooseGamePlayer(event_attendee_id: $event_attendee_id) {
      id
      event_attendee {
        user {
          id
          name
          email
        }
        badge_code
      }
      event_attendee_id
      current_points
      total_points
      created_at
      dashboard_last_viewed_at
    }
  }
`;

/**
 * __useGooseGamePlayerQuery__
 *
 * To run a query within a React component, call `useGooseGamePlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGooseGamePlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGooseGamePlayerQuery({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useGooseGamePlayerQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GooseGamePlayerQuery,
    GooseGamePlayerQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GooseGamePlayerQuery,
    GooseGamePlayerQueryVariables
  >(GooseGamePlayerDocument, baseOptions);
}
export function useGooseGamePlayerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GooseGamePlayerQuery,
    GooseGamePlayerQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GooseGamePlayerQuery,
    GooseGamePlayerQueryVariables
  >(GooseGamePlayerDocument, baseOptions);
}
export type GooseGamePlayerQueryHookResult = ReturnType<
  typeof useGooseGamePlayerQuery
>;
export type GooseGamePlayerLazyQueryHookResult = ReturnType<
  typeof useGooseGamePlayerLazyQuery
>;
export type GooseGamePlayerQueryResult = ApolloReactCommon.QueryResult<
  GooseGamePlayerQuery,
  GooseGamePlayerQueryVariables
>;
